module.exports = __webpack_public_path__ + "img/tree-06-j-trunk.b3f7a052.png";